/**
 * @generated SignedSource<<c168fec646d6f83919ca2626516354fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeviceScheduleScreen_DeviceFragment$data = {
  readonly deviceName: string;
  readonly deviceSchedule: {
    readonly id: string;
  } | null | undefined;
  readonly id: string;
  readonly timeZone: string | null | undefined;
  readonly " $fragmentType": "DeviceScheduleScreen_DeviceFragment";
};
export type DeviceScheduleScreen_DeviceFragment$key = {
  readonly " $data"?: DeviceScheduleScreen_DeviceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeviceScheduleScreen_DeviceFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeviceScheduleScreen_DeviceFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deviceName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeZone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DeviceSchedule",
      "kind": "LinkedField",
      "name": "deviceSchedule",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ScreenDevice",
  "abstractKey": null
};
})();

(node as any).hash = "3cdc95a22421729fd1f7c50832ac383f";

export default node;
